import { render, staticRenderFns } from "./PersonalDimension.vue?vue&type=template&id=255a8dbe&scoped=true&"
import script from "./PersonalDimension.vue?vue&type=script&lang=js&"
export * from "./PersonalDimension.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDimension.vue?vue&type=style&index=0&id=255a8dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a8dbe",
  null
  
)

export default component.exports